import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const DO_FETCH_REQUEST = 'DO_FETCH_REQUEST'
export const DO_FETCH_SUCCESS = 'DO_FETCH_SUCCESS'
export const DO_FETCH_FAILURE = 'DO_FETCH_FAILURE'
export const DO_CLEAR = 'DO_CLEAR'

const normalizarTexto = valor => {
  if (typeof valor !== 'string') return ''
  return valor.trim()
}

const normalizarStatusTecnico = status => {
  const texto = normalizarTexto(status)

  if (!texto) return ''

  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .toLowerCase()
}

const montarAcoesResumo = acoes => {
  if (!Array.isArray(acoes)) {
    return ''
  }

  const titulos = acoes
    .map(item => normalizarTexto(item?.tituloAcao))
    .filter(Boolean)

  return titulos.join(' + ')
}

const normalizarPlanos = planos => {
  if (!Array.isArray(planos)) {
    return []
  }

  return planos.map(item => ({
    id: item.idPlano,
    numeroPlano: item.numeroPlano,
    titulo: item.titulo,
    tipoPlano: item.tipo,
    ciclo: 'do',
    status: normalizarStatusTecnico(item.status),
    deadline: item.deadline,
    diasParaAtrasoCritico: item.diasParaAtrasoCritico,
    acoesResumo: montarAcoesResumo(item.acoes),
    lojaNome: item.lojaNome,
    produtoNome: item.produtoNome,
    responsavel: item.responsavel
  }))
}

export const fetchDo = ({ empresaId, projetoId, idiomaId, dataInicial, dataFinal }) => {
  return async dispatch => {
    dispatch({ type: DO_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.post('/pdca/listaplanos', {
        empresaId,
        projetoId,
        idiomaId,
        tipoPlano: '',
        ciclo: 'do',
        dataInicial,
        dataFinal
      })

      const data = response?.data
      const planos = normalizarPlanos(data?.planos)

      dispatch({
        type: DO_FETCH_SUCCESS,
        payload: {
          itens: planos,
          total: planos.length,
          filtros: {
            dataInicial,
            dataFinal
          }
        }
      })
    } catch (error) {
      dispatch({
        type: DO_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar planos do ciclo Do.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearDo = () => ({
  type: DO_CLEAR
})